<template>
    <div id="permission">
        <div class="tree-panel">
            <div class="title title--tree">
                权限管理
            </div>
            <div class="tree-container" :style="{height: `${windowHeight - 150}px`}">
                <el-tree class="filter-tree"
                         highlight-current
                         :current-node-key="0"
                         ref="tree"
                         draggable
                         :data="treeData"
                         :props="defaultProps"
                         node-key="id"
                         :expand-on-click-node='false'
                         @node-click="nodeClickHandler"
                         :default-expanded-keys="defaultExpandedArray">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span :title="data.name">{{ data.name }}</span>
                    </span>
                </el-tree>
            </div>

        </div>
        <div class="main-panel" :style="{width: `${windowWidth - 580}px`}">
            <div v-show="!isShowAddEdit && !isShowDetail">
                <div style="padding-bottom: 10px;">
                    <span v-show="currentNode.id == 0">
                        <el-button type="primary" size="medium" v-if="isShowByPermission('/wyms/apiManage/insertApiPermission')" @click="showAddEdit(null, true)">新增文件夹</el-button>
                        <el-button type="danger" size="medium" v-if="isShowByPermission('/wyms/apiManage/deleteApiPermissionZ')" @click="batchDeleteHandler()">删除文件夹</el-button>
                    </span>
                    <span v-show="currentNode.id != 0">
                        <el-button type="primary" size="medium" v-if="isShowByPermission('/wyms/apiManage/updateApiPermission')" @click="showAddEdit(currentNode, true)">修改权限</el-button>
                        <el-button type="primary" size="medium" v-if="isShowByPermission('/wyms/apiManage/insertApiPermission')" @click="showAddEdit(null, false)">新增权限</el-button>
                        <el-button type="danger" size="medium" v-if="isShowByPermission('/wyms/apiManage/deleteApiPermissionZ')" @click="batchDeleteHandler()">删除权限</el-button>
                    </span>
                    <el-input size="medium" class="search-input search-input--right" placeholder="权限名称"
                              v-model="apiName" @keyup.enter.native="handleInputChange">
                        <el-button slot="append" icon="el-icon-search" size="medium"
                                   @click="handleInputChange"></el-button>
                    </el-input>
                </div>
                <el-table
                    :height="windowHeight - 206"
                    :data="apiList"
                    style="width: 100%" border
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        label="名称"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <span class="resource-name" @click="showDetail(scope.row)">
                                {{ scope.row.apiName }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="currentNode.id != 0"
                        label="路径地址"
                        prop="urlPath"
                        align="center"
                        width="400"
                    >
                    </el-table-column>
                    <el-table-column
                        v-if="currentNode.id != 0"
                        label="限流时间"
                        prop="limitingTime"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        v-if="currentNode.id != 0"
                        label="限流次数"
                        prop="limitingNumber"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        label="路径描述"
                        prop="urlDescribe"
                        align="center"
                    >
                    </el-table-column>

<!--                    <el-table-column-->
<!--                        label="创建时间"-->
<!--                        prop="createTime"-->
<!--                        align="center"-->
<!--                    >-->
<!--                    </el-table-column>-->
<!--                    <el-table-column-->
<!--                        label="创建人"-->
<!--                        align="center"-->
<!--                        prop="createUser"-->
<!--                    >-->
<!--                    </el-table-column>-->
                    <el-table-column
                        label="操作"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <div v-show="currentNode.id == 0">
                                <el-button type="text" v-if="isShowByPermission('/wyms/apiManage/updateApiPermission')" @click="showAddEdit(scope.row, true)">编辑权限</el-button>
                                <el-button type="text" v-if="isShowByPermission('/wyms/apiManage/deleteApiPermissionZ')" @click="deleteHandler(scope.row.id)">删除文件夹</el-button>
                            </div>
                            <div v-show="currentNode.id != 0">
                                <el-button type="text" v-if="isShowByPermission('/wyms/apiManage/updateApiPermission')" @click="showAddEdit(scope.row, false)">编辑权限</el-button>
                                <el-button type="text" v-if="isShowByPermission('/wyms/apiManage/deleteApiPermissionZ')" @click="deleteHandler(scope.row.id)">删除权限</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-container">
                    <el-pagination
                        @size-change="queryApiPermissionByPidFunc"
                        @current-change="queryApiPermissionByPidFunc"
                        :current-page.sync="pagination.pageNo"
                        :page-sizes="[10 , 20, 30, 50]"
                        :page-size.sync="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :page-count="pagination.pages"
                        :total="pagination.total"
                    >
                    </el-pagination>
                </div>
            </div>
            <div v-show="isShowAddEdit">
                <div style="padding-bottom: 10px;border-bottom: 1px solid #e4e7ed;">
                    <el-button type="default" size="medium" @click="isShowAddEdit = false">返回</el-button>
                    <el-button type="primary" size="medium" @click="addEditConfirm()">保存</el-button>
                </div>
                <div class="content">
                    <div style="width: 810px;padding-top:20px;margin: 0 auto;">
                        <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                            <el-form-item label="名称" prop="apiName">
                                <el-input v-model="formData.apiName" :maxlength="500" placeholder=""></el-input>
                            </el-form-item>
                            <div v-if="!isFolder">
                                <el-form-item label="路径地址" prop="urlPath">
                                    <el-input v-model="formData.urlPath" :maxlength="500" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item label="限流时间" prop="limitingTime">
                                    <el-input v-model="formData.limitingTime" :maxlength="500"
                                              placeholder="只能输入数字"></el-input>
                                </el-form-item>
                                <el-form-item label="限流次数" prop="limitingNumber">
                                    <el-input v-model="formData.limitingNumber" :maxlength="500"
                                              placeholder="只能输入数字"></el-input>
                                </el-form-item>
                            </div>
                            <el-form-item label="路径描述" prop="urlDescribe">
                                <el-input v-model="formData.urlDescribe" :maxlength="500" placeholder=""></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <div v-show="isShowDetail">
                <div style="padding-bottom: 10px;border-bottom: 1px solid #e4e7ed;">
                    <el-button type="default" size="medium" @click="isShowDetail = false">返回</el-button>
                </div>
                <div class="detail-container">
                    <div class="detail__title">
                        名称
                    </div>
                    <div class="detail__value">
                        {{detailInfo.apiName}}
                    </div>
                    <div class="detail__title">
                        路径地址
                    </div>
                    <div class="detail__value">
                        {{detailInfo.urlPath || '--'}}
                    </div>
                    <div class="detail__title">
                        路径描述
                    </div>
                    <div class="detail__value">
                        {{detailInfo.urlDescribe}}
                    </div>
                    <div class="detail__title">
                        创建时间
                    </div>
                    <div class="detail__value">
                        {{detailInfo.createTime}}
                    </div>
                    <div class="detail__title">
                        创建人
                    </div>
                    <div class="detail__value">
                        {{detailInfo.createUser}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import windowResize from '@/mixins/windowResize.js';
    import baseMixin from '@/mixins/baseMixin.js';

    import {
        queryApiPermTree,
        queryApiPermissionByPid,
        deleteApiPermission,
        insertApiPermission,
        updateApiPermission,
        queryApiPermission
    } from '@/api/apiPermission';

    const validateNumber = (rule, value, callback) => {
        value = `${value}`.trim();
        if (value === '') {
            callback();
        } else if (!/^\d+$/.test(value)) {
            callback(new Error('请输入数字'));
        } else {
            callback();
        }
    };

    export default {
        name: "apiPermissionList",
        mixins: [windowResize, baseMixin],
        data() {
            return {
                multipleSelection: [],
                treeData: [],
                treeSearchText: '',
                defaultProps: {
                    children: 'childrens',
                    label: 'label'
                },
                currentType: 0,
                currentNode: {},
                defaultExpandedArray: [0],
                apiList: [],
                apiName: '',
                isShowAddEdit: false,
                formData: {
                    apiName: '',
                    limitingNumber: '',
                    limitingTime: '',
                    urlDescribe: '',
                    urlPath: ''
                },
                rules: {
                    apiName: [
                        {required: true, message: '请输入名称', trigger: 'blur'},
                    ],
                    urlPath: [
                        {required: true, message: '请输入路径地址', trigger: 'blur'},
                    ],
                    limitingTime: [
                        {validator: validateNumber},
                    ],
                    limitingNumber: [
                        {validator: validateNumber},
                    ],
                },
                editNode: null,
                isFolder: false,
                isShowDetail: false,
                detailInfo: {}
            }
        },
        created() {
            this.queryApiPermTreeFunc();
        },
        methods: {
            isShowByPermission,
            showDetail(item) {
                queryApiPermission({
                    id: item.id
                })
                    .then(data => {
                        data.limitingNumber = data.limitingNumber || '';
                        data.limitingTime = data.limitingTime || '';
                        this.detailInfo = data;
                        this.isShowDetail = true;
                    })
            },
            addEditConfirm() {
                this.$refs.form.validate(isValid => {
                    if (isValid) {
                        console.log(this.editNode);
                        // console.log(this.editNode.pId);
                        const editNode = this.editNode;
                        const args = {
                            apiName: this.formData.apiName,
                            limitingNumber: this.formData.limitingNumber,
                            limitingTime: this.formData.limitingTime,
                            urlDescribe: this.formData.urlDescribe,
                            urlPath: this.formData.urlPath
                        };
                        if (this.editNode === null) {
                            args.parentId = this.currentNode.id;
                        } else {
                            args.parentId = this.editNode.pId !== undefined ? this.editNode.pId : this.editNode.parentId;
                            args.id = this.editNode.id;
                        }
                        new Promise(resolve => {
                            if (this.editNode === null) {
                                insertApiPermission(args).then(resolve);
                            } else {
                                updateApiPermission(args).then(resolve);
                            }
                        })
                            .then(() => {
                                this.$message.success(`${this.editNode !== null ? '新增' : '编辑'}成功`);
                                this.queryApiPermTreeFunc();
                                this.isShowAddEdit = false;
                                this.isShowDetail = false;
                            })
                    }
                });
            },
            showAddEdit(editNode = null, isFolder = false) {
                this.isFolder = isFolder;

                if (editNode !== null) {
                    queryApiPermission({
                        id: editNode.id
                    })
                        .then(data => {
                            data.limitingNumber = data.limitingNumber || '';
                            data.limitingTime = data.limitingTime || '';
                            this.formData = data;
                            this.editNode = editNode;
                            this.isShowAddEdit = true;
                            this.isShowDetail = false;
                        })
                } else {
                    this.formData = {
                        apiName: '',
                        limitingNumber: '',
                        limitingTime: '',
                        urlDescribe: '',
                        urlPath: ''
                    };
                    this.editNode = editNode;
                    this.isShowAddEdit = true;
                }

            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleInputChange() {
                this.pagination.pageNo = 1;
                this.queryApiPermissionByPidFunc();
            },
            queryApiPermTreeFunc() {
                queryApiPermTree({
                    module: false
                })
                    .then(data => {
                        this.treeData = [data];
                        this.currentNode = data;
                        this.queryApiPermissionByPidFunc();
                    })
            },
            nodeClickHandler(node) {
                this.currentNode = node;
                let pNode = this.$refs.tree.getNode(this.currentNode.id);
                const parentIdList = [];
                while (!!pNode.parent) {
                    if (node.level != 0) {
                        parentIdList.unshift(pNode.data.id);
                    }
                    pNode = pNode.parent;
                }
                parentIdList.unshift(0);
                this.isShowAddEdit = false;
                this.isShowDetail = false;
                this.defaultExpandedArray = parentIdList;
                this.queryApiPermissionByPidFunc();
            },
            queryApiPermissionByPidFunc() {
                queryApiPermissionByPid({
                    apiName: this.apiName,
                    pid: this.currentNode.id,
                    pageSize: this.pagination.pageSize,
                    pageNo: this.pagination.pageNo
                })
                    .then(data => {
                        this.apiList = data.dataList;
                        this.pagination.total = data.pagination.total;
                    })
            },
            batchDeleteHandler() {
                if (this.multipleSelection.length === 0) {
                    this.$message.error('请选择要删除的权限');
                } else {
                    this.deleteHandler(this.multipleSelection.map(({id}) => id).join(','));
                }
            },
            deleteHandler(ids) {
                if (!this.currentNode) {
                    this.$message.error('请选择一个节点');
                } else {
                    this.$confirm("确认要删除吗？", "删除", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                        lockScroll: false
                    }).then(() => {
                        deleteApiPermission({
                            ids,
                            pid: this.currentNode.id
                        })
                            .then(() => {
                                this.queryApiPermissionByPidFunc();
                                this.queryApiPermTreeFunc();
                            })
                    });
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";

    #permission {
        height: 100%;
    }

    .tree-header {
        padding: 12px;
        top: 0;

        & > div:first-of-type {
            margin-bottom: 12px;
        }
    }

    .tree-header--placeholder {
        height: 94px;
    }

    .tree-container {
        height: 300px;
        overflow-y: auto;
        @include scrollBar;
        width: 260px;

    }

    .tree-panel {
        position: relative;
        float: left;
        width: 260px;
        border-right: 1px solid #f1f1f1;
    }

    .main-panel {
        float: left;
        padding: 12px;
    }

    .title {
        margin: 10px 0;
        border-left: 4px solid #409EFF;
        padding-left: 12px;
        height: 16px;
        line-height: 16px;
    }

    .title--tree {
        margin: 22px 12px 15px 12px;
    }

    .line {
        margin: 20px 0;

        .label, .value {
            display: inline-block;
            vertical-align: top;
        }

        .label {
            width: 7em;
            margin-right: 10px;
            text-align: right;
        }

        .value {
            word-break: break-all;
            line-height: 21px;
        }

    }

    .resource-name {
        color: #409EFF;
        cursor: pointer;
    }

    .role-list {
        margin-top: 30px;
        @include clearfix;

        .role-item {
            float: left;
            margin-right: 10px;
        }
    }

    .title--large {
        margin: 30px 0;
    }
    .detail-container {
        width: 752px;
        margin: 0 auto;
        .device-name {
            font-size: 20px;
        }
        .detail__title {
            margin: 22px 0 14px 0;
            border-left: 4px solid #409EFF;
            padding-left: 12px;
            height: 16px;
            line-height: 16px;
        }
        .detail__value {
            line-height: 38px;
            background-color: #F7FBFD;
            padding-left: 16px;
            color: #777;
            @include clearfix;
            .upload-file-item {
                height: 72px;
                width: 40px;
                img {
                    margin: 16px 0;
                    width: 40px;
                    height: 40px;
                }
                .file-name {
                    display: none;
                }
            }
        }
    }
</style>
<style lang="scss">
    .dialog-form .is-current.is-focusable > .el-tree-node__content {
        background-color: #20a0ff !important;
        color: #fff !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/permissionSystem/apiPermission/apiPermissionList.vue